(function(){
'use strict';

/*
 * Limit results on asynchronous search fundraisers drop-down
 */

limitResults.$inject = ["$q"];
function limitResults($q) {
  return function (input) {
    var deferred = $q.defer();
    if (!_.isUndefined(input)) {
      input.then(function (result) {
        deferred.resolve(result.slice(0, 5));
      });
    }

    return deferred.promise;
  };
}

angular.module('classy').filter('limitResults', limitResults);
})();